export default "__VITE_ASSET__CcZzVUsA__"